import React from "react"
import Header from "../common/header/Header"
import { BrowserRouter as Router, Switch, Route, Redirect, useLocation } from "react-router-dom"
import Home from "../home/Home"
import Footer from "../common/footer/Footer"
import About from "../about/About"
import Pricing from "../pricing/Pricing"
import Listings from "../listings/Listings"
import ListingDetail from "../listings/ListingDetail"
import Services from "../services/Services"
import Contact from "../contact/Contact"
import SignIn from "../auth/SignIn"
import SignUp from "../auth/SignUp"
import ForgotPassword from "../auth/ForgotPassword"
import ResetPassword from "../auth/ResetPassword"
import PrivateRoute from "../dashboard/PrivateRoute"
import DashboardLayout from "../dashboard/DashboardLayout"
import DashboardHome from "../dashboard/DashboardHome"
import SavedSearches from "../dashboard/SavedSearches"
import SavedHomes from "../dashboard/SavedHomes"
import RentalApplications from "../dashboard/RentalApplications"
import Bookings from "../dashboard/Bookings"
import Profile from "../dashboard/Profile"
import AdminPrivateRoute from "../admin/AdminPrivateRoute"
import AdminLayout from "../admin/AdminLayout"
import AdminDashboardHome from "../admin/AdminDashboardHome"
import AdminUsers from "../admin/AdminUsers"
import AdminListings from "../admin/AdminListings"
import AdminBookings from "../admin/AdminBookings"
import AdminQuoteRequests from "../admin/AdminQuoteRequests"
import AdminContactSubmissions from "../admin/AdminContactSubmissions"

function AdminRoutes() {
  return (
    <AdminPrivateRoute>
      <AdminLayout>
        <Switch>
          <Route exact path='/admin' component={AdminDashboardHome} />
          <Route path='/admin/users' component={AdminUsers} />
          <Route path='/admin/listings' component={AdminListings} />
          <Route path='/admin/bookings' component={AdminBookings} />
          <Route path='/admin/quote-requests' component={AdminQuoteRequests} />
          <Route path='/admin/contact-submissions' component={AdminContactSubmissions} />
        </Switch>
      </AdminLayout>
    </AdminPrivateRoute>
  )
}

function DashboardRoutes() {
  return (
    <PrivateRoute>
      <DashboardLayout>
        <Switch>
          <Route exact path='/dashboard' component={DashboardHome} />
          <Route path='/dashboard/saved-searches' component={SavedSearches} />
          <Route path='/dashboard/saved-homes' component={SavedHomes} />
          <Route path='/dashboard/applications' component={RentalApplications} />
          <Route path='/dashboard/bookings' component={Bookings} />
          <Route path='/dashboard/profile' component={Profile} />
        </Switch>
      </DashboardLayout>
    </PrivateRoute>
  )
}

function AppContent() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith("/dashboard")
  const isAdmin = location.pathname.startsWith("/admin")

  return (
    <>
      {!isDashboard && !isAdmin && <Header />}
      <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/about' component={About} />
        <Route exact path='/services' component={Services} />
        <Route exact path='/listings' component={Listings} />
        <Route path='/listings/:id' component={ListingDetail} />
        <Route path='/blog'>
          <Redirect to='/listings' />
        </Route>
        <Route exact path='/pricing' component={Pricing} />
        <Route exact path='/contact' component={Contact} />
        <Route path='/dashboard' component={DashboardRoutes} />
        <Route path='/admin' component={AdminRoutes} />
        <Route exact path='/signin' component={SignIn} />
        <Route exact path='/signup' component={SignUp} />
        <Route exact path='/forgot-password' component={ForgotPassword} />
        <Route path='/reset-password/:token?' component={ResetPassword} />
      </Switch>
      {!isDashboard && !isAdmin && <Footer />}
    </>
  )
}

const Pages = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default Pages
